import React from 'react';
import { BadgePercentIcon, HandshakeIcon, TargetIcon } from 'lucide-react';
import { Reveal } from './showcase/Reveal';
import { AccountabilityDashboard } from './showcase/AccountabilityDashboard';
const principles: {
  title: string;
  body: string;
  icon: typeof HandshakeIcon;
}[] = [{
  title: 'The retainer means something',
  icon: HandshakeIcon,
  body: 'Month to month, no annual contract. If we stop producing, you stop paying.'
}, {
  title: 'We never touch your commission',
  icon: BadgePercentIcon,
  body: 'No per-lead fees, no per-minute meters, no cut of your deals. Your closings are 100% yours.'
}, {
  title: 'We know where deals stall',
  icon: TargetIcon,
  body: 'Two years at Zillow selling agents their software and advertising. Kevin watched great agents lose to faster ones.'
}];
export function Principles() {
  return <section id="principles" aria-label="How Viridia operates" className="border-b border-white/5 bg-ink-800" data-id="element-176" data-mp="360qa8whr7z69">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-177" data-mp="yusimrtiqvab">
        <ul className="grid gap-5 md:grid-cols-3" data-id="element-178" data-mp="tx0pjuh5134j">
          {principles.map((item, index) => {
          const Icon = item.icon;
          return <li key={item.title} className="h-full" data-id="element-179" data-mp="p47q9m4fumzu" data-mpi={index}>
                <Reveal delay={0.06 * index} className="h-full" data-id="element-180" data-mp="l58mw5ycuyai">
                  <div className="flex h-full flex-col rounded-xl border border-white/10 bg-ink-700 p-7" data-id="element-181" data-mp="g5chq3dx90td">
                    <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-182" data-mp="b69e8ndlb2ni">
                      <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-183" data-mp="66encjtted2g" />
                    </span>
                    <h2 className="mt-6 font-display text-lg font-semibold tracking-tight text-white" data-id="element-184" data-mp="26mjgkfd8v3f">
                      {item.title}
                    </h2>
                    <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-185" data-mp="1wjm3qquoydh1">
                      {item.body}
                    </p>
                  </div>
                </Reveal>
              </li>;
        })}
        </ul>

        <Reveal className="mt-12" data-id="element-186" data-mp="3uu31i13oy2g2">
          <p className="text-sm text-white/55" data-id="element-187" data-mp="3uv4hmjzkdf4n">
            The retainer buys accountability. This lands in your inbox every Friday.
          </p>
          <div className="mt-5" data-id="element-188" data-mp="3l2gmrus59l8k">
            <AccountabilityDashboard data-id="element-189" data-mp="3l3rrbwteyx0q" />
          </div>
        </Reveal>
      </div>
    </section>;
}